import type { EditorState } from '@/stateManagement';

const getOverridden = (state: EditorState) => state.linkPanel.overridden;

export { getOverridden };
